type GenericObject = {
    [key: string]: any;
};

export const countPropertiesWithValues = (object: GenericObject): number =>
    Object.keys(object).filter((key) => object[key] !== null && object[key] !== undefined).length;
